import script from "./BlogLang.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogLang.vue?vue&type=script&lang=ts&setup=true"

import "./BlogLang.vue?vue&type=style&index=0&id=0016cf86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0016cf86"]])

export default __exports__